import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import css from './TnaDifferencesOverview.module.css';

import * as tnaServices from '../../../../../services/tnaServices';

function TnaDifferencesOverview() {
    const [data, setData] = useState([]);
    const [filter, setFilter] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        // Fetch differences data here and set it to state
        // Example: setData(fetchedData);
        tnaServices
            .getAllTnaDifferences(1)
            .then((res) => {
                setData(res.data);
            })
            .catch((err) => {
                console.error('Error fetching TNA differences data:', err);
            });
    }, []);

    return (
        <div>
            <h2>TNA Differences Overview</h2>
            <table className={css.table}>
                <thead className={css.thead}>
                    <tr>
                        <th>ID</th>
                        <th>From</th>
                        <th>To</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((diff) => (
                        <tr
                            key={diff.tnaDifferenceId}
                            className={css.row}
                            onClick={() =>
                                navigate(
                                    '/tna/difference/details/' +
                                        diff.tnaDifferenceId +
                                        '?from=' +
                                        diff.tnaFromId +
                                        '&to=' +
                                        diff.tnaToId
                                )
                            }
                        >
                            <td>{diff.tnaDifferenceId}</td>
                            <td>{diff.tnaFromTitle}</td>
                            <td>{diff.tnaToTitle}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default TnaDifferencesOverview;
